import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { productDetailsImages } from '../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DETAILS_PRODUCT_DISCOVERABILITY
        }
        question="What should I keep in mind while adding Product Categories?"
      />
    ),
    answer: (
      <div>
        Select relevant categories that help buyers <strong>discover</strong>{' '}
        your product inside AWS Marketplace.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DETAILS_PRODUCT_DISCOVERABILITY
        }
        question="What should I keep in mind while adding Keywords for search results?"
      />
    ),
    answer: (
      <div>
        Add relevant <strong>single words or phrases</strong> that buyers might
        use when searching for your product. Keywords help improve your
        product's search visibility but are{' '}
        <strong>not publicly displayed</strong>.
      </div>
    ),
  },
]

interface FlyoutProductDetailsProductDiscoverabilityFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const FlyoutProductDetailsProductDiscoverabilityFaqs: React.FC<
  FlyoutProductDetailsProductDiscoverabilityFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Product Discoverability"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={productDetailsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
